import React, {Component} from 'react';
import RichTextEditor from 'react-rte';

const toolbarConfig = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
    {label: 'Italic', style: 'ITALIC'},
    {label: 'Underline', style: 'UNDERLINE'}
  ],
  BLOCK_TYPE_DROPDOWN: [
    {label: 'Normal', style: 'unstyled'},
    {label: 'Heading Large', style: 'header-one'},
    {label: 'Heading Medium', style: 'header-two'},
    {label: 'Heading Small', style: 'header-three'}
  ],
  BLOCK_TYPE_BUTTONS: [
    {label: 'UL', style: 'unordered-list-item'},
    {label: 'OL', style: 'ordered-list-item'}
  ]
};

// class MyStatefulEditor extends Component {
function MyStatefulEditor(props) {
//   static propTypes = {
//     setValue: PropTypes.func,
//     getValues: PropTypes.func,
//     name: PropTypes.string
//   };

//   state = {
//     value: this.props.value ?? RichTextEditor.createEmptyValue()
//   }

  const [textValue, setTextValue] = React.useState(RichTextEditor.createValueFromString(props.getValues(props.name+"HTML") ? props.getValues(props.name+"HTML") : props.getValues(props.name), 'html') ?? RichTextEditor.createEmptyValue())

  const onChange = (value) => {
    // setState({value});
    // console.log(value)
    setTextValue(value)
    if (props.setValue && props.name) {
        // setValue()
        props.setValue(props.name, value.toString("html"))
    }
    // setTextValue(value)
    // if (props.onChange) {
    //   // Send the changes up to the parent component as an HTML string.
    //   // This is here to demonstrate using `.toString()` but in a real app it
    //   // would be better to avoid generating a string on each change.
    //   props.onChange(
    //     value.toString('html')
    //   );
    // }
  };

    // const getValue = () => {
    //     const defaultValue = RichTextEditor.createEmptyValue()
    //     if (props.getValues) {
    //         const value = props.getValues(props.name)
    //         return RichTextEditor.createValueFromString(value, 'html')
    //         // return  ?? defaultValue
    //     }
    //     return defaultValue
    // };

  return (
    <RichTextEditor
      className="w-100"
      value={textValue}
      onChange={onChange}
      toolbarConfig={toolbarConfig}
    //   onChange={val => {
    //       console.log(val)
    //   }}
    />
  );
}

export default MyStatefulEditor